export default function megabytesToBytes(mb) {
  return Math.round(mb * 1048576);
}